import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type { Model } from 'frontend-payments/routes/authenticated';

export default class AuthenticatedController extends Controller {
  declare model: Model;

  @service declare accountSwitcher: Services['account-switcher'];
  @service declare router: Services['router'];
  @service declare session: Services['session'];

  get isLoadingAccountData(): boolean {
    return (
      this.model.account.isRunning ||
      this.model.availableAccounts.isRunning ||
      this.model.transactionsRequest.isRunning ||
      this.accountSwitcher.loadCurrentAccountTask.isRunning
    );
  }

  @action
  refreshRoute(): void {
    if (!this.session.isPayByLinkOpened) {
      return;
    }

    this.session.closePayByLink();
    this.router.refresh('authenticated');
    this.router.transitionTo('authenticated.overview');
  }
}
